import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { IStreet, IStreetListRequest } from '@web/dtos';
import { StreetGateway } from './street.gateway';

@Injectable({
  providedIn: 'root',
})
export class StreetStore {
  private readonly gateway: StreetGateway = new StreetGateway();
  private readonly streetListRequest: WritableSignal<IStreetListRequest | null> =
    signal<IStreetListRequest | null>(null);

  #streetResource: ResourceRef<IApiResponse<IStreet[]> | undefined> = resource({
    params: this.streetListRequest,
    loader: ({
      params,
    }: ResourceLoaderParams<IStreetListRequest | null>): Promise<
      IApiResponse<IStreet[]> | undefined
    > => {
      return params
        ? firstValueFrom(this.gateway.get(params))
        : Promise.resolve(undefined);
    },
  });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#streetResource.isLoading()
  );

  readonly streets: Signal<IStreet[]> = computed(() => {
    if (this.#streetResource.hasValue()) {
      const data: IStreet[] = this.#streetResource.value()
        ?.data as unknown as IStreet[];
      return data ?? [];
    }
    return [];
  });

  loadStreets(request: IStreetListRequest): void {
    this.streetListRequest.set(request);
  }

  reset(): void {
    this.streetListRequest.set(null);
  }

  reload(): void {
    this.#streetResource.reload();
  }
}
